<template>
    <div class="fs5-collapse-info">
        <div class="box-modal-subtitle" :style="custom_margin_style">
            <div :class="['modal-subtitle', collapsed ? 'border-radius-bottom-none' : '']">
                <p v-text="view[0]"></p>
                <div @click="collpaseToggle()">
                    <img :class="[collapsed ? 'shadow' : '']" :src="'/internacional/public/office5/img/franchise_dashboard/svg/info.svg'">
                </div>
            </div>
            <div class="modal-info" v-if="collapsed">
                <p v-html="view[1]"></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-collapse-info',
        props: ['view'],
        data() {
            return {
                collapsed: false,
                custom_margin_style: '',
            }
        },

        mounted(){
            this.adjustCssForTools();
        },


        methods: {
            collpaseToggle(){
                this.collapsed = !this.collapsed
            },

            urlParam(name){
              var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

              if(results && results.length) {
                  return results[1];
              }

              return 0;
            },

            adjustCssForTools(){
                if(this.urlParam('opentool') == 'autoresponder'){
                  this.custom_margin_style = 'margin: 1em 0em 0em 0em !important;';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-collapse-info{
        font-family: 'Lato';
        .box-modal-subtitle{
            display: flex;
            flex-direction: column;
            margin: 1em 2em 0em 2em;
            .modal-subtitle{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                text-align: left;
                background: $dv5-color8;
                border-radius: 5px;
                color:$dv5-color6 !important;
                padding: 0.5em 1em;
                z-index: 1;
                .shadow{
                    box-shadow: 0 0 .8em $fs5-color19;
                }
                p{
                    margin: 0 !important;
                }
                img{
                    height: .9em;
                    cursor: pointer;
                    transition: .4s;
                    border-radius: 50%;
                }
            }
            .modal-info{
                padding: 1em;
                border: 1px solid $fs5-color1;
                border-top: none;
                border-radius: 0 0 .8em .8em;
                color: $dv5-color6;
                line-height: 1.3em;
                animation-name: moveDiv;
                animation-duration: .4s;
                p{
                    font-size: .85em;
                }
            }
        }
    }
    .border-radius-bottom-none{
        border-radius: 5px 5px 0 0 !important;
    }
    @keyframes moveDiv {
        from {margin-top: -2em; opacity: 0;}
        to {margin-top: 0; opacity: 1;}
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/collapse_info/index.vue